import React, { useEffect, useRef } from 'react';

export interface ContextMenuItem {
  id: string;
  label: string;
  action: () => void;
}

interface Props {
  x: number;
  y: number;
  visible: boolean;
  items: ContextMenuItem[];
  onClose: () => void;
}

export const ContextMenu: React.FC<Props> = ({ x, y, visible, items, onClose }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    const onDoc = (e: MouseEvent) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target as Node)) onClose();
    };
    if (visible) {
      document.addEventListener('keydown', onKey);
      document.addEventListener('mousedown', onDoc);
    }
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onDoc);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div
      ref={ref}
      style={{ left: x, top: y, color: 'black' }}
      className="fixed bg-white border rounded shadow-lg z-50 w-44 text-sm"
    >
      {items.map(item => (
        <button
          key={item.id}
          onClick={() => { item.action(); onClose(); }}
          className="w-full text-left px-3 py-2 hover:bg-gray-100"
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default ContextMenu;
